import React from 'react'

import NeatVsCompetitorCompare from '@/components/templates/NeatVsCompetitorCompare'
import trendsInsightsImg from '@/assets/track-receipts/trends-insights.png'
import allFilesImg from '@/assets/features-potential/all-files.jpg'
import fyleLogo from '@/assets/neat-competitor/fyle-logo.png'
import avatarImage from '@/assets/testimonials/avatar.png'

const pageId = 'neatVsFyle'

const overview = [
  {
    title: 'Receipt tracking from anywhere',
    text:
  <><p>Neat and Fyle are both receipt tracking and scanning applications. These receipt scanning apps provide various ways to upload your documents easily and have powerful data extraction and verification technologies. Both applications provide unlimited receipt scanning. </p>
    <p>Fyle provides the use of tracking receipts through their Gmail and Office 365/Outlook plugins. There is also a connection with Slack that receipts can be sent to. Fyle’s mobile app can also scan receipts. Text and email forwarding of receipts can be sent to Fyle.</p>
    <p>Neat provides unlimited scans and storage of scanned receipts via mobile phone, email, dragging & dropping documents into the Neat application or using a compatible scanner.</p>
  </>,
  },
  {
    title: 'Expense & financial reporting',
    text:
  <><p>Neat provides expense reporting as well as additional spending and tax focused reports. The Automated Insights upgrade allows you to connect directly to financial institutions to power expanded reports and insights such as net cash flow, cash balance, and profit & loss, all without requiring users to scan or manually enter each expense.  Scanned receipts and other documents can easily be paired with your transactions through guided workflows to make accounting and audit preparedness easy.</p>
    <p>Fyle allows direct connections to credit card networks only to facilitate credit card reconciliation and provides expense related reporting, insights, approval workflows and reimbursement.</p>
  </>,
  },
  {
    title: 'Pricing',
    text:
  <><p>Neat and Fyle differ in plan offers.</p>
    <p>Fyle charges based upon amount of users while offering 3 plans. Each plan requires a minimum amount of users. Their annual growth plan charges $11.99 a month per user with a minimum of 5 users totalling around $720 a year. Their annual business plan charges $14.99 a month per user with a minimum of 10 users totalling around $1,800 a year. They also offer an enterprise plan for companies with over 250+ employees with custom pricing.</p>
    <p>Currently, in order to try Fyle requires requesting a demo.</p>
    <p>Neat offers a base plan at $200 a year. The base plan can also be enhanced with add-ons. Neat offers their VIP service to provide premium help that includes 1:1 training guided by Neat experts, a dedicated support team, and early access to new features and exclusive offers at $250 a year. Neat’s Automated Insights plan provides insights into your finances with real-time accounting and expense reporting at $350 a year. You can also get Neat’s base plan and both VIP and Automated Insights for $400 a year.</p>
    <p>You can try Neat with a 14-day free trial.</p>
  </>,
  },
]

const comparisons = [
  {
    rowTitle: 'Overview',
    neatText: 'Neat helps you scan and track receipts and documents. Neat’s powerful OCR technology extracts key information for automation. You can also monitor top expense categories, cash balances, and analyze finances with live data. Neat is a smart file organization and financial reporting tool.',
    competitorText: 'Fyle is an expense management platform designed to streamline and automate the expense reporting process for businesses. It helps companies track, manage, and reimburse employee expenses.',
  },
  {
    rowTitle: 'Platforms supported',
    neatText: 'Neat can be accessed anywhere, anytime as a web-based app, iOS & Android.',
    competitorText: 'Web-based, iOS & Android.',
  },
  {
    rowTitle: 'Best for',
    neatList: [
      'Accountants/Bookkeepers',
      'Small to Medium size businesses',
      'Freelancers',
    ],
    competitorList: [
      'Accountants/Bookkeepers',
      'Small to Medium size businesses',
    ],
  },
  {
    rowTitle: 'Customer support',
    neatList: [
      'Chat',
      'Email',
      'Phone',
      '24/7 Knowledge Base',
      'Webinars',
    ],
    competitorList: [
      'Phone',
      'Help Center',
      'Webinars',
    ],
  },
  {
    rowTitle: 'Features',
    neatList: [
      'Document scanning by mobile, email, drag & drop to app, or compatible scanner',
      'Unlimited file storage',
      'Organize files by expense type, tax category, and more',
      'Easily filter and search for documents',
      'Track expenses with reporting and insights capabilities built-in',
      'Real-time insights - including net cash flow, top expense categories, cash balance, profit and loss',
      'Connect to bank accounts',
      'Categorization of expenses can be done without requiring a file to be captured',
      'Bank-level data security',
    ],
    competitorList: [
      'Receipt scanning by Gmail, Outlook, email fowarding, SMS and Slack',
      'Unlimited scanning',
      'Expense reporting & insights',
      'Approval workflows',
      'Reimbursements',
      'Direct connections to credit card networks',
    ],
  },
  {
    rowTitle: 'Integrations',
    neatList: [
      'Intuit Quickbooks',
      'Intuit Turbotax',
      'H&R Block',
      'Quicken',
      'Outlook',
      'Campaign Monitor',
      'Mailchimp',
      'Google Contacts',
      'Constant Contact',
    ],
    competitorList: [
      'Intuit Quickbooks',
      'Sage',
      'Xero',
      'Oracle Netsuite',
      'Sage300',
      'Gmail',
      'Office 365',
      'Slack',
    ],
  },
  {
    rowTitle: 'Pricing',
    neatList: [
      'Neat - $200/yr',
      'Neat w/ VIP Service - $250/yr',
      'Neat w/ Automated Insights (AI) - $350/yr',
      'Neat w/ AI & VIP - $400/yr',
      'Free trial available',
    ],
    competitorList: [
      'Growth starting at $720/yr - min 5 users',
      'Business starting at $1,800/yr - min 10 users',
      'Enterprise is custom pricing - over 250+',
    ],
  },
]

const featureComparison = [
  {
    feature: 'Receipt Scanning',
    neat: true,
    competitor: true,
  },
  {
    feature: 'Unlimited Parsing',
    neat: true,
    competitor: true,
  },
  {
    feature: 'iOS & Android app',
    neat: true,
    competitor: true,
  },
  {
    feature: 'Expense Report',
    neat: true,
    competitor: true,
  },
  {
    feature: 'Unlimited Storage',
    neat: true,
    competitor: false,
  },
  {
    feature: 'Reconciliation',
    neat: true,
    competitor: false,
  },
  {
    feature: 'Connect Bank Accounts',
    neat: true,
    competitor: false,
  },
  {
    feature: 'Real-time insights',
    neat: true,
    competitor: false,
  },
  {
    feature: 'Free Trial',
    neat: true,
    competitor: false,
  },
]

const testimonialSliderProps = {
  author: 'Joann D.',
  text: 'I have been using Neat for at least 7 years, and it\'s made tracking receipts and generating year end reports a breeze.',
  avatar: avatarImage,
  slides: [
    { image: trendsInsightsImg },
    { image: allFilesImg },
  ],
}

export default function NeatVsFyle() {
  return (
    <NeatVsCompetitorCompare
      comparisons={comparisons}
      competitorLogo={fyleLogo}
      competitorName="Fyle"
      ctaTitle="Easy and efficient - now that's Neat!"
      featureComparison={featureComparison}
      heroTitle={<>Receipt expense management to easily capture and monitor your documents</>}
      overview={overview}
      pageTitle="Neat vs. Fyle"
      testimonialSliderProps={testimonialSliderProps}
    />
  )
}

NeatVsFyle.layoutProps = {
  pageId,
  showFooter: false,
  showHeader: false,
}
